import { render, staticRenderFns } from "./WarrantiesList.vue?vue&type=template&id=a7652938&"
import script from "./WarrantiesList.vue?vue&type=script&lang=js&"
export * from "./WarrantiesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports